import { render, staticRenderFns } from "./BadanKelembagaan.vue?vue&type=template&id=a381d332"
import script from "./BadanKelembagaan.vue?vue&type=script&lang=js"
export * from "./BadanKelembagaan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports